import { gsap } from "gsap";


/**
 * Search Module
 * Header search functionality
 */


export function initSearchHeader() {
    const searchTrigger = document.querySelectorAll(".headerBasic__search");
    const searchForm = document.querySelector(".headerBasic__searchForm");

    // Validasi elemen ada
    if (!searchTrigger.length || !searchForm) {
        console.warn("Search elements not found");
        return;
    }

    searchTrigger.forEach((el) => {
        el.addEventListener("click", (e) => {
            e.preventDefault();
            searchForm.classList.toggle("active");

            // Focus cursor ke input search
            const searchInput = document.querySelector(
                '.headerBasic__searchForm input[name="search"]'
            );
            if (searchInput) {
                searchInput.focus();
            }
        });
    });
}

export function initMobileMenu() {
    const menuTriggers = document.querySelectorAll(".toggle-menu-mobile");
    const menuBasics = document.querySelectorAll(".headerBasic");

    const menuMobile = document.querySelector(".headerBasic__menu-vertical");
    const sosialMobile = document.querySelector(".headerBasic__menu-social");
    const menuHorizontal = document.querySelectorAll(".headerBasic__menu-horizontal");

    let isOpen = false;

    // 🔥 create overlay
    const overlay = document.createElement("div");
    overlay.classList.add("menu-overlay");
    document.body.appendChild(overlay);

    // initial state overlay
    gsap.set(overlay, {
        opacity: 0,
        pointerEvents: "none"
    });

    // klik overlay = close
    overlay.addEventListener("click", () => {
        if (isOpen) toggleMenu();
    });

    function toggleMenu() {
        isOpen = !isOpen;

        menuBasics.forEach((menu) => {
            menu.classList.toggle("show");
        });

        if (isOpen) {
            // SHOW overlay
            gsap.to(overlay, {
                opacity: 1,
                pointerEvents: "auto",
                duration: 0.3
            });

            // SHOW overlay
            // gsap.to(menuBasics, {
            //     backgroundColor: "orange !important",
            //     duration: 0.3
            // });


            // OPEN
            gsap.to(menuMobile, {
                height: "auto",
                opacity: 1,
                duration: 0.4,
                ease: "power2.out"
            });

            gsap.to(menuHorizontal, {
                // height: 0,
                opacity: 0,
                duration: 0.3,
                ease: "power2.in"
            });

            gsap.to(sosialMobile, {
                height: "auto",
                y: 0,
                opacity: 1,
                duration: 0.4,
                delay: 0.1,
                ease: "power2.out"
            });

        } else {
            // HIDE overlay
            gsap.to(overlay, {
                opacity: 0,
                pointerEvents: "none",
                duration: 0.3
            });

            // CLOSE
            gsap.to(menuMobile, {
                height: 0,
                opacity: 0,
                duration: 0.3,
                ease: "power2.in"
            });

            gsap.to(menuHorizontal, {
                // height: "auto",
                opacity: 1,
                duration: 0.4,
                delay: 0.1,
                ease: "power2.out"
            });

            gsap.to(sosialMobile, {
                height: 0,
                y: 20,
                opacity: 0,
                duration: 0.3,
                ease: "power2.in"
            });
        }
    }

    menuTriggers.forEach((el) => {
        el.addEventListener("click", toggleMenu);
    });
}

// export function initMobileMenu() {
//     const menuTriggers = document.querySelectorAll(".toggle-menu-mobile");
//     const menuBasics = document.querySelectorAll(".headerBasic");

//     const menuMobile = document.querySelector(".headerBasic__menu-vertical");
//     const sosialMobile = document.querySelector(".headerBasic__menu-social");

//     const menuHorizontal = document.querySelectorAll(".headerBasic__menu-horizontal");

//     let isOpen = false;

//     menuTriggers.forEach((el) => {
//         el.addEventListener("click", () => {
//             isOpen = !isOpen;

//             // toggle class
//             menuBasics.forEach((menu) => {
//                 menu.classList.toggle("show");
//             });

//             if (isOpen) {
//                 // OPEN animation
//                 gsap.to(menuMobile, {
//                     height: "auto",
//                     opacity: 1,
//                     duration: 0.4,
//                     ease: "power2.out"
//                 });

//                 gsap.to(menuHorizontal, {
//                     height: 0,
//                     opacity: 0,
//                     duration: 0.3,
//                     ease: "power2.in"
//                 });

//                 gsap.to(sosialMobile, {
//                     height: "auto",
//                     y: 0,
//                     opacity: 1,
//                     duration: 0.4,
//                     delay: 0.1,
//                     ease: "power2.out"
//                 });

//             } else {
//                 // CLOSE animation
//                 gsap.to(menuMobile, {
//                     height: 0,
//                     opacity: 0,
//                     duration: 0.3,
//                     ease: "power2.in"
//                 });

//                 gsap.to(menuHorizontal, {
//                     height: "auto",
//                     opacity: 1,
//                     duration: 0.4,
//                     delay: 0.1,
//                     ease: "power2.out"
//                 });

//                 gsap.to(sosialMobile, {
//                     height: 0,
//                     y: 20,
//                     opacity: 0,
//                     duration: 0.3,
//                     ease: "power2.in"
//                 });
//             }
//         });
//     });
// }